<template>
  <RxkDialog
    v-model="exportVisible"
    title="导出文件"
    width="1150px"
    :showFooter="false"
    @sure="sure"
  >
    <div class="importDialog">
      <div class="left-part">
        <ul class="tabs">
          <li
            class="tab"
            v-for="i in exportStatusList"
            :key="i.value"
            :class="selectedTab === i.value ? 'selected' : ''"
            @click="changeTab(i)"
          >
            {{ `${i.label}` }}
          </li>
        </ul>
      </div>
      <div class="importDialog-main">
        <p class="tips">提示：关闭该弹窗，不影响导出，导出完成会弹窗提示！</p>
        <div class="s-table-box">
          <RxkVTable @register="registerTable" />
        </div>
      </div>
    </div>
  </RxkDialog>
</template>
<script lang="tsx" setup>
import { RxkDialog } from '@/components/common/RxkDialog'
import { computed, ref, watch } from 'vue'
import { deleteExport, downloadExportFileApi, getGlobalExportList } from '@/apis/objectManage'
import { RxkVTable } from '@/components/common/RxkVTable'
import { useTable } from '@/components/common/RxkVTable/src/hooks/useTable'
import { ElMessageBox } from 'element-plus'
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

const [registerTable, { reload, setProps }] = useTable({
  columns: getBasicColumns(),
  api: getGlobalExportList,
  showPagination: true,
  immediate: true,
  searchInfo: {
    model: {
      status: ''
    }
  }
})
watch(
  () => props.visible,
  val => {
    if (val) {
      initData()
    } else {
      reset()
    }
  }
)
// 初始化数据
function initData() {
  getTableData() // 第一次进来请求一次
  autoRefreshTable()
}
function getBasicColumns() {
  return [
    {
      key: 'tableName',
      title: '导出对象'
    },
    {
      key: 'webFileName',
      title: '导出文件',
      render: ({ cellData }) => {
        return (
          <span
            style="color: #5687FF;text-decoration: underline; cursor: pointer;"
            onClick={() => handleDownload(cellData)}
          >
            {cellData.webFileName}
          </span>
        )
      }
    },
    {
      key: 'remark',
      title: '导出结果'
    },
    {
      key: 'exportUserName',
      title: '导出者'
    },
    {
      key: 'createTime',
      title: '导出时间'
    },
    {
      key: 'operate',
      title: '操作',
      fixed: 'right',
      render: ({ cellData }) => {
        return (
          <>
            <RxkButton text onClick={() => handleDelete(cellData)}>
              删除
            </RxkButton>
          </>
        )
      }
    }
  ]
}
const emit = defineEmits(['update:visible'])
const exportVisible = computed({
  get() {
    return props.visible
  },
  set(newVal) {
    emit('update:visible', newVal)
  }
})
const exportStatusList = ref<Recordable[]>([
  {
    value: '',
    label: '全部文件',
    tabShow: true,
    tableLabel: '-',
    totalField: 'allCount'
  },
  {
    value: 0,
    label: '正在导出',
    tabShow: true,
    tableLabel: '正在导出...',
    color: '#5687FF',
    totalField: 'progressCount'
  },
  {
    value: 10,
    label: '导出完成',
    tabShow: true,
    tableLabel: '导出完成',
    color: '#333333',
    totalField: 'finishCount'
  }
])
const selectedTab = ref('')
function changeTab(item: Recordable) {
  selectedTab.value = item.value
  getTableData()
}
function sure() {}
// 获取表格数据
function getTableData() {
  setProps({
    searchInfo: {
      model: {
        status: selectedTab.value
      }
    }
  })
  reload()
  // todo tab中的统计还没有出接口数据
  // getGlobalExportList({
  //   pageSize: paginationData.value.pageSize,
  //   pageNum: paginationData.value.pageNum,
  //   model: {
  //     status: selectedTab.value
  //   }
  // }).then(res => {
  //   console.log(res, 'opppp')
  //   tableData.value = res.data.records || []
  //   setProps({
  //     data: tableData.value
  //   })
  //   console.log(tableData, 'tableData123')
  // })
}

const timer = ref<any>()

// 自动刷新表格
function autoRefreshTable() {
  timer.value && clearInterval(timer.value)
  timer.value = setInterval(() => {
    getTableData()
  }, 5000)
}

function handleDelete(data: Recordable) {
  console.log(data, 'oop')
  ElMessageBox.confirm('确认删除？', '提示', {
    type: 'warning'
  }).then(() => {
    deleteExport({ id: data.id }).then(() => {
      ElMessage.success('删除成功')
    })
  })
}
function handleDownload(data: Recordable) {
  downloadExportFileApi({ id: data.id })
}
function stopAutoRefresh() {
  timer.value && clearInterval(timer.value)
}
function reset() {
  stopAutoRefresh()
}
</script>
<style scoped lang="scss">
.importDialog {
  display: flex;
  width: 100%;
  height: 600px;
  .left-part {
    width: 180px;
    height: 100%;
    padding: 9px 16px;
    .tabs {
      width: 100%;
      .tab {
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
        &.selected {
          background: #ecf2fe;
          color: #5687ff;
          font-weight: 700;
        }
      }
    }
  }
  .importDialog-main {
    height: 100%;
    box-sizing: border-box;
    min-width: 0;
    flex: 1;
    border-left: 1px solid #e9e9e9;
    overflow: auto;
    .tips {
      font-size: 12px;
      color: #999999;
      height: 45px;
      line-height: 45px;
      padding: 0 16px;
    }
    .s-table-box {
      height: calc(100% - 70px);
    }
  }
}
</style>
